export default __webpack_public_path__ + "static/media/UCDoor2.3593a0b8.png";